import type { Product, TaxRate } from "./types";

export function productMatches(p: Product, raw: string): boolean {
  const q = raw.trim().toLowerCase();
  if (q === "") return true;
  const digits = q.replace(/\D/g, "");
  const parts = [p.label, p.unit, p.description, p.product_code].map((s) => (s || "").toLowerCase());
  if (parts.some((s) => s.includes(q))) return true;
  if (digits.length >= 3 && (p.product_code || "").replace(/\D/g, "").includes(digits)) return true;
  return false;
}

export function excerpt(raw: string | null | undefined, max = 140): string {
  const t = (raw || "").replace(/<[^>]+>/g, " ").replace(/&nbsp;/g, " ").replace(/\s+/g, " ").trim();
  if (t.length <= max) return t;
  return `${t.slice(0, max).trimEnd()}…`;
}

export function taxOf(rates: TaxRate[], id: number | null | undefined): TaxRate | undefined {
  if (id == null) return undefined;
  return rates.find((r) => r.id === Number(id));
}

export function taxLabel(rates: TaxRate[], id: number | null | undefined): string {
  const r = taxOf(rates, id);
  return r ? r.label : "—";
}

export function lineTaxCents(ht: number, rateBp: number): number {
  return Math.round((ht * rateBp) / 10000);
}

export function isActive(p: { active?: boolean | number | null }): boolean {
  return Number(p.active) === 1 || p.active === true;
}
